import React from "react";
import { AnimatePresence } from "framer-motion";

import { FileInput } from "./FileInput";

export const UploadVisualAreaContent = React.memo(() => {
    return (
        <AnimatePresence mode="wait">
            <FileInput key="file-input" />
        </AnimatePresence>
    );
});
